import styled from 'styled-components';

export const inputContainer = styled.div`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  /* overflow: hidden; */
  border-radius: 12px;

  &.error {
    input {
      border: 1px solid #eb2b2b !important;
    }
  }

  &.success {
    input {
      border: solid 1px var(--green-dark);
    }
  }
`;

export const input = styled.input`
  padding: 0 40px;
  height: 54px;
  width: -webkit-fill-available;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  background: #fdfdfd;
  border: 1px solid rgba(182, 182, 182, 0.2);
  border-radius: 10px;
  color: var(--dark);
  padding-right: 50px;

  &:focus ~ .input-label,
  &:not(:placeholder-shown) ~ .input-label {
    top: 0px;
    font-size: 11px;
  }

  &:focus {
    border: 1px solid #367af7;
  }

  &:not(:placeholder-shown) ~ .input-label {
    color: #367af7;
  }

  &:focus {
    outline: none;
  }
`;

export const label = styled.label`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  /* position: absolute;
  top: 15px;
  left: 15px; */
  color: var(--dark-light);
  transition: 0.2s ease all;
`;

export const message = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: var(--dark-light);
  padding-left: 10px;

  &.error-message {
    color: var(--danger);
  }

  &.success-message {
    color: var(--green-dark);
  }
`;

export const img = styled.img`
  &.icon {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 40px;
    height: 40px;
    border-radius: 40px;
  }
`;
export const Icon = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: -15px;
  align-items: center;
  display: flex;
  justify-content: center;
  border-radius: 24px;
  width: 24px;
  height: 24px;
  background: #eef1f6;
  margin: auto;
`;

export const InputBox = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 40px;
  background: #616e84;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Div = styled.div``;
